import { useFormikContext } from "formik";
import React from "react";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { IOtherIncomes } from "../../../../config/interfaces";
import { useAppDispatch } from "../../../../redux/Store";
import { showHintModal } from "../../../../redux/slice/HintModalSlice";
import FASvgIcon from "../../../FASvgIcon";
import { FormField, NumericInputField } from "../../../fields";

const OIAnyIncomeFromNonNotifiedCountryForm: React.FC = () => {
  const { values, handleBlur, errors, touched, setFieldValue } = useFormikContext<IOtherIncomes>();

  const dispatch = useAppDispatch();

  return (
    <section className="mb-5">
      <div className="section-title-wrap">
        <h5>
          Income from retirement benefits account maintained in a non-notified country
          <span
            className="info-wrap"
            role="button"
            onClick={() => {
              dispatch(
                showHintModal({
                  componentName: "RetirementBenefitsNonNCHint"
                })
              );
            }}
          >
            <FASvgIcon icon={faInfoCircle} />
          </span>
        </h5>
      </div>
      <FormField label="Amount" sm={6}>
        <NumericInputField
          showLeftIcon={true}
          name="IncomeNonNotifiedCountryAmount"
          value={values.IncomeNonNotifiedCountryAmount}
          onBlur={handleBlur("IncomeNonNotifiedCountryAmount")}
          onChange={(value) => setFieldValue("IncomeNonNotifiedCountryAmount", value)}
          isInvalid={
            Boolean(errors.IncomeNonNotifiedCountryAmount) && touched.IncomeNonNotifiedCountryAmount
          }
          errorMsg={errors.IncomeNonNotifiedCountryAmount}
        />
      </FormField>
    </section>
  );
};

export default OIAnyIncomeFromNonNotifiedCountryForm;
